import React, {useCallback, useState} from 'react';

import {TrueViewForProducts} from '@optimaxdev/analytics/desktop/components/trueViewForProducts/trueViewForProducts';

import {EEC_ACCESSORIES_IMPRESSIONS_FROM_CART} from 'constants/analytics/events/eec';
import {sendAnalyticsForAccessoriesFromCart} from 'desktop/pages/checkout/store/sagas/paymentStep/paymentMethods/amazon/utils/sendAnalyticsButtonAuth';

import {AccessoryType, AccessoryWindowType} from '../../store/reducers/accessories/accessoriesType';

type PropsType = {
    displayedAccessories: Array<AccessoryWindowType>;
    children: (args: ChildPropsType) => React.ReactElement;
};
type ChildPropsType = {
    onViewAccessory: (accessory: AccessoryType | AccessoryType[], isLastAccessory: boolean) => void;
};

/**
 * send analytics about sticky accessory and viewedAccessories
 * @param {PropsType} - props
 * @returns {JSX.Element} - returns react component wrapper; sets callback for viewing items to children.
 */
export const TrueViewForAccessories: React.FC<PropsType> = ({children, displayedAccessories}) => {
    const [accessoriesViewList, setAccessoriesToList] = useState<AccessoryType[]>([]);
    const [isLastElement, setLastElement] = useState(false);

    const handleViewAccessory = useCallback(
        (accessory: AccessoryType | AccessoryType[], isLastAccessory = false) => {
            setLastElement(isLastAccessory);
            setAccessoriesToList((prevState: AccessoryType[]) =>
                Array.isArray(accessory) ? accessory : [...prevState, accessory],
            );
        },
        [],
    );

    const handleSendAnalytics = useCallback(
        (accessoryItem: AccessoryType[]) => {
            sendAnalyticsForAccessoriesFromCart(
                accessoryItem,
                displayedAccessories,
                EEC_ACCESSORIES_IMPRESSIONS_FROM_CART,
            );
        },
        [displayedAccessories],
    );

    return (
        <TrueViewForProducts
            isLastProduct={isLastElement}
            productsList={accessoriesViewList}
            sendAnalytics={handleSendAnalytics}
            setProducts={handleViewAccessory}
            waitTime={30000}
        >
            <>{children({onViewAccessory: handleViewAccessory})}</>
        </TrueViewForProducts>
    );
};
